import { dmApi } from "../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";
import { serialize } from "../../helpers/Utils";

export const dashBoardApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        searchPieChartData: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/pie-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['pieChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchBarChartData: build.query({
            query: (data) => {
                let paramData = serialize(data);

                return {
                    url: `/receiving-data/bar-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['barChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createEmployeeData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/receiving-data/employees-data/store`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['employeeReceiving'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee Data")
            },

        }),


        //  Dashboard Api's 

        getBiggestDaily: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/dashboard/biggest-daily?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ['biggestDailyData'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        // Fresh Fruit Running Total 

        getFreshFruitRunningTotal: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/dashboard/fresh-fruit-running-total?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['freshFruitRunningTotalQuery'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        // Season Duration
        getSeason: build.query({
            query: () => ({
                url: `/dashboard/get-season-duration`,
                method: 'GET',
                headers: getAuthorizationHeader(),
            }),
            providesTags: ['seasonDuration'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        // Cold-storage & Ripening

        getColdStorageAndRipening: build.query({
            query: () => ({
                url: `/dashboard/coldstorage-and-ripening-data`,
                method: 'GET',
                headers: getAuthorizationHeader(),
            }),
            providesTags: ['coldStorageAndRipeningQuery'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        saveSeason: build.mutation({
            query: (requestBody) => ({
                url: `/dashboard/set-season-duration`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['seasonDuration' ,'freshFruitRunningTotalQuery'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Saved", "Season");
            },
        }),
    }),

});

export const {
    useSearchPieChartDataQuery,
    useSearchBarChartDataQuery,
    useCreateEmployeeDataMutation,
    useGetBiggestDailyQuery,
    useGetFreshFruitRunningTotalQuery,
    useGetSeasonQuery,
    useSaveSeasonMutation,
    useGetColdStorageAndRipeningQuery
} = dashBoardApi;

